import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const HikisariYokinShumokuKbn = props => {
  return <Dropdown.Static kubunKey='hikisari_yokin_shumoku_kbn' {...props} />
}
